import { Table } from 'antd';
import React, { useEffect, useState } from 'react';

function TableComponent(props) {
  const {
    expandable,
    columns,
    defaultPageSize,
    data = [],
    rowKey,
    onChange,
    loadingData = false,
    tableClassName = '',
    paginationConfig, // required for showing pagination
    ...rest
  } = props;
  const [paginationProps, setPaginationProps] = useState({
    pageSizeOptions: [10, 15, 20, 50, 100],
    defaultPageSize: 10,
    responsive: true,
    showSizeChanger: false,
    position: ['bottomCenter']
  });

  useEffect(() => {
    setPaginationProps({ ...paginationProps, ...paginationConfig });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [paginationConfig]);

  if (
    paginationConfig.defaultPageSize &&
    paginationProps.defaultPageSize !== paginationConfig.defaultPageSize
  )
    return <div />;

  return (
    <Table
      expandable={expandable}
      columns={columns}
      bordered={false} // by default false if want then pass true from props
      dataSource={data}
      rowKey={rowKey}
      className={tableClassName}
      onChange={onChange} // for getting pagination,sorting and filter data
      pagination={paginationConfig ? paginationProps : false} // for server side or client side pagination
      loading={{
        spinning: loadingData, // keep it true to set loader
        size: 'large' // currently kept large loader
      }}
      {...rest}
    />
  );
}

export default TableComponent;
